import { ThemeProvider } from "@mui/material";
import "./App.css";
import { LoginPage } from "./pages/LoginPage";
import theme from "./theme";
import { ProjectsPage } from "./pages/ProjectsPage";
import { WorkPage } from "./pages/WorkPage";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DatabasePage } from "./pages/DatabasePage";
import { DashboardPage } from "./pages/DashboardPage";
import { ProfilePage } from "./pages/ProfilePage";

function App() {
  const [login, setLogin] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (token) {
      setLogin(true);
    }
  }, []);

  if (!login) {
    return (
      <div className="App">
        <ThemeProvider theme={theme}>
          <LoginPage setLogin={setLogin} />
        </ThemeProvider>
      </div>
    );
  } else {
    return (
      <div className="App">
        <ThemeProvider theme={theme}>
          <BrowserRouter basename={"/app"}>
            <Routes>
              <Route
                path="/"
                element={<ProjectsPage setLogin={setLogin} />}
              ></Route>
              <Route
                path="/workspace/:projectId"
                element={<WorkPage setLogin={setLogin} />}
              ></Route>
              <Route
                path="/database/:projectId"
                element={<DatabasePage setLogin={setLogin} />}
              ></Route>
              <Route
                path="/dashboard/:projectId"
                element={<DashboardPage setLogin={setLogin} />}
              ></Route>
              <Route
                path="/profile"
                element={<ProfilePage setLogin={setLogin} />}
              ></Route>
              <Route
                path="/profile/:tab"
                element={<ProfilePage setLogin={setLogin} />}
              ></Route>
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </div>
    );
  }
}

export default App;
